import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Modal, Carousel } from "react-bootstrap";
import { changeTimzone } from "./../../helpers/stubs";
import { deleteScreenshot } from "../../Slices/candidateSlice";

function ImageCarousel({
  setfShowCarousel,
  currentIndexOfScreenshotForCrousal,
  screenshotImages,
  showDeleteButton,
  userId,
  selectedDay,
}) {
  const {
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);
  const [index, setIndex] = useState(currentIndexOfScreenshotForCrousal);
  const [show, setshow] = useState(true);
  const dispatch = useDispatch();
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const deleteScreenShotImage = () => {
    const { _id } = screenshotImages.at(index);
    setshow(false);
    setfShowCarousel(false);
    dispatch(deleteScreenshot({ screenshotId: _id, userId, day: selectedDay }));
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        setshow(false);
        setfShowCarousel(false);
      }}
      autoFocus
      animation
    >
      <Modal.Header closeButton>
        <Row className="w-100">
          <Col sm="2" className="text-center">
            <Modal.Title id="contained-modal-title-vcenter">
              {`${changeTimzone(screenshotImages[index].timeTakenAt, timezone)
                .format("h:mm a")
                .toUpperCase()}`}
            </Modal.Title>
          </Col>
          <Col sm="8" className="text-start">
            <Modal.Title id="contained-modal-title-vcenter">{` <${screenshotImages[index].task.name}/>`}</Modal.Title>
          </Col>
          {showDeleteButton && (
            <Col sm="2" className="text-end mt-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="red"
                className="bi bi-trash"
                viewBox="0 0 25 25"
                onClick={deleteScreenShotImage}
                style={{ cursor: "pointer" }}
              >
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path
                  fillRule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </Col>
          )}
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Carousel
          fade
          interval={null}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {screenshotImages.map((courselImage) => (
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={courselImage.url}
                alt="Loading..."
                style={{ height: "75vh" }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
}

export default ImageCarousel;
